import React from 'react'
import ZoneHeadEnquiryForm from '../../features/zoneHead/ZoneHeadEnquiryForm'

const ZoneHeadEnquiryFormPage = () => {
  return <ZoneHeadEnquiryForm/>
}

export default ZoneHeadEnquiryFormPage